import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { selectors } from '../../../credit_application/reducer';
import { selectors as flexFinalizeSelectors } from '../../../flex-finalize/reducer';
import ApprovalBread from './ApprovalBread';
import ApprovalFlex from './ApprovalFlex';
function Approval() {
    const approvedApplication = useSelector((state) => selectors.approvedApplication(state));
    const { applicationServiceProviderPriority } = approvedApplication;
    const signingUrl = useSelector((state) => flexFinalizeSelectors.signingUrl(state));
    const lenderName = useSelector((state) => selectors.lenderName(state));
    return (_jsx("div", { className: "approve-charge-content", children: applicationServiceProviderPriority.productType === 'line_of_credit' ? (_jsx(ApprovalBread, {})) : lenderName === 'ACI' ? (_jsx(ApprovalFlex, { approvedApplication: approvedApplication, signingUrl: signingUrl })) : (_jsx(ApprovalBread, {})) }));
}
export default Approval;
